import { TimepickerComponent } from './timepicker/timepicker.component';

export const Components = [
	TimepickerComponent,
];
